var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("b-row", { attrs: { cols: "12" } }, [
        _c("h5", { staticClass: "mt-4" }, [
          _vm._v("\n      Datos del paciente\n    ")
        ])
      ]),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "mt-2", attrs: { cols: "12" } },
        [
          _c(
            "b-col",
            { attrs: { cols: "3" } },
            [
              _c(
                "b-form-group",
                {
                  attrs: {
                    id: "input-group-1",
                    label: "Dni/Nie/Pasaporte:",
                    "label-for": "input-reason"
                  }
                },
                [
                  _c("b-form-input", {
                    model: {
                      value: _vm.patient.idNumber,
                      callback: function($$v) {
                        _vm.$set(_vm.patient, "idNumber", $$v)
                      },
                      expression: "patient.idNumber"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { attrs: { cols: "9" } },
            [
              _c(
                "b-form-group",
                {
                  attrs: {
                    id: "input-group-1",
                    label: "Nombre completo:",
                    "label-for": "input-reason"
                  }
                },
                [
                  _c("b-form-input", {
                    model: {
                      value: _vm.patient.completeName,
                      callback: function($$v) {
                        _vm.$set(_vm.patient, "completeName", $$v)
                      },
                      expression: "patient.completeName"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        { attrs: { cols: "12" } },
        [
          _c(
            "b-col",
            { attrs: { cols: "3" } },
            [
              _c(
                "b-form-group",
                {
                  attrs: {
                    id: "input-group-1",
                    label: "Fecha de nacimiento:",
                    "label-for": "input-reason"
                  }
                },
                [
                  _c("b-form-input", {
                    model: {
                      value: _vm.patient.birdDate,
                      callback: function($$v) {
                        _vm.$set(_vm.patient, "birdDate", $$v)
                      },
                      expression: "patient.birdDate"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { attrs: { cols: "1" } },
            [
              _c(
                "b-form-group",
                {
                  attrs: {
                    id: "input-group-1",
                    label: "Edad:",
                    "label-for": "input-reason"
                  }
                },
                [
                  _c("b-form-input", {
                    model: {
                      value: _vm.patient.age,
                      callback: function($$v) {
                        _vm.$set(_vm.patient, "age", $$v)
                      },
                      expression: "patient.age"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { attrs: { cols: "4" } },
            [
              _c(
                "b-form-group",
                {
                  attrs: {
                    id: "input-group-1",
                    label: "Email:",
                    "label-for": "input-reason"
                  }
                },
                [
                  _c(
                    "b-input-group",
                    {
                      scopedSlots: _vm._u([
                        {
                          key: "append",
                          fn: function() {
                            return [
                              _c(
                                "b-input-group-text",
                                [_c("b-icon", { attrs: { icon: "envelope" } })],
                                1
                              )
                            ]
                          },
                          proxy: true
                        }
                      ])
                    },
                    [
                      _vm._v(" "),
                      _c("b-form-input", {
                        model: {
                          value: _vm.patient.email,
                          callback: function($$v) {
                            _vm.$set(_vm.patient, "email", $$v)
                          },
                          expression: "patient.email"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { attrs: { cols: "4" } },
            [
              _c(
                "b-form-group",
                {
                  attrs: {
                    id: "input-group-1",
                    label: "Teléfono:",
                    "label-for": "input-reason"
                  }
                },
                [
                  _c(
                    "b-input-group",
                    {
                      scopedSlots: _vm._u([
                        {
                          key: "append",
                          fn: function() {
                            return [
                              _c(
                                "b-input-group-text",
                                [
                                  _c("b-icon", { attrs: { icon: "telephone" } })
                                ],
                                1
                              )
                            ]
                          },
                          proxy: true
                        }
                      ])
                    },
                    [
                      _vm._v(" "),
                      _c("b-form-input", {
                        model: {
                          value: _vm.patient.contactPhone,
                          callback: function($$v) {
                            _vm.$set(_vm.patient, "contactPhone", $$v)
                          },
                          expression: "patient.contactPhone"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1880343f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1880343f","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/webapp/professional/patient.vue
// module id = 3985
// module chunks = 30